import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RocketLaunchIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rocket_launch"}/>
}
